
export const throttle = (callback: any, delay: number) => {
	let isThrottled = false, args: IArguments, context: any;

	function wrapper() {
		if (isThrottled) {
			args = arguments;
			context = this;
			return;
		}

		isThrottled = true;
		callback.apply(this, arguments);

		setTimeout(() => {
			isThrottled = false;
			if (args) {
				wrapper.apply(context, args);
				args = context = null;
			}
		}, delay);
	}

	return wrapper;
}
export const throttle2 = (func: Function, limit: number) => {
	let lastFunc: number;
	let lastRan: number;
	return function() {
		const context = this
		const args = arguments
		if (!lastRan) {
			func.apply(context, args)
			lastRan = Date.now()
		} else {
			clearTimeout(lastFunc)
			lastFunc = <any>setTimeout(function() {
				if ((Date.now() - lastRan) >= limit) {
					func.apply(context, args)
					lastRan = Date.now()
				}
			}, limit - (Date.now() - lastRan))
		}
	}
}
export const debounce = (func: (...params: any[]) => any, delay: number) => {
	let inDebounce: number;
	return function(...args: any[]) {
		const context = this
		clearTimeout(inDebounce)
		inDebounce = <any>setTimeout(() => func.apply(context, args), delay)
	}
}
export const millisToHoursAndMinutes = (millis: number) => {
	return millisToDuration(millis, DurationPrecision.minutes);
}
export enum DurationPrecision {
	hours = 0,
	minutes = 1,
	seconds = 2,
	millis = 3,
}
export type TLMDDuration  = {
	hours?: number,
	minutes?: number,
	seconds?: number,
	milliseconds?: number
}
export const millisToDuration = (millis: number, precision?: DurationPrecision, returnZeros = true): TLMDDuration => {
	millis = Math.round(millis);
	let hours = Math.floor(millis / 3600000);
	millis -= hours * 3600000;
	let minutes = Math.floor(millis / 60000);
	millis -= minutes * 60000;
	let seconds = Math.floor(millis / 1000);
	millis -= seconds * 1000;

	seconds += precision !== undefined && precision < DurationPrecision.millis && millis >= 500 ? 1 : 0;
	minutes += precision !== undefined && precision < DurationPrecision.seconds && seconds >= 30 ? 1 : 0;
	hours += precision !== undefined && precision < DurationPrecision.minutes && minutes >= 30 ? 1 : 0;

	return {
		hours: hours,
		minutes: precision !== undefined && precision < DurationPrecision.minutes ? returnZeros ? 0 : undefined : minutes,
		seconds: precision !== undefined && precision < DurationPrecision.seconds ? returnZeros ? 0 : undefined : seconds,
		milliseconds: precision !== undefined && precision < DurationPrecision.millis ? returnZeros ? 0 : undefined  : millis
	}
}
export const durationToMillis = (duration: TLMDDuration): number => {
	let millis = 0;
	millis +=  duration.hours !==undefined ? duration.hours * 3600000 : 0;
	millis +=  duration.minutes !==undefined ? duration.minutes * 60000 : 0;
	millis +=  duration.seconds !==undefined ? duration.seconds * 1000 : 0;
	millis +=  duration.milliseconds !==undefined ? duration.milliseconds : 0;
	return millis;
}
export const durationToStrings = (duration: TLMDDuration): { hours: string, minutes: string, seconds: string, millis: string } => {
	return {
		hours: String(duration.hours),
		minutes: duration.minutes !== undefined ? (duration.minutes < 10 ? '0' : '') + String(duration.minutes) : undefined,
		seconds: duration.seconds !== undefined ? (duration.seconds < 10 ? '0' : '') + String(duration.seconds) : undefined,
		millis: duration.milliseconds !== undefined ?  (duration.milliseconds < 10 ? '00' : duration.milliseconds < 100 ? '0' : '') + String(duration.milliseconds) : undefined
	}
}

export const isLeapYear = (year: number | Date): boolean => {
	return getDaysInYear(year) > 365;
}
export const getDaysInYear = (year: number | Date): number => {
	let yr = (<Date>year).getFullYear ? (<Date>year).getFullYear() : <number>year;
	let date = new Date();
	date.setTime(0);
	date.setFullYear(yr);
	date.setMonth(0);
	date.setDate(1);

	let millisStart = date.getTime();

	date.setFullYear(yr + 1);
	let millisEnd = date.getTime();
	return ((millisEnd - millisStart) / (24 * 3600000));
}

const monthInDays = [[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]];
const monthStartingDays = [[0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335]];
export const getDaysInMonth = (year: number | Date, month: number): number => {
	let yr = (<Date>year).getFullYear ? (<Date>year).getFullYear() : <number>year;
	let mnth = (<Date>year).getFullYear ? (<Date>year).getMonth() : month;
	return monthInDays[(isLeapYear(year) ? 1 : 0)][mnth];
}
/**
* return 1..365 for common years and 1..366 for leap years
 */
export const getDayOfTheYear = (date: Date): number => {
	return monthStartingDays[(isLeapYear(date) ? 1 : 0)][date.getMonth()] + date.getDate();
}
/**
* Calculate on which day the year ends
* 0=sunday
 */
const lastDayOfTheYear = (year: number | Date): number => {
	let yr = (<Date>year).getFullYear ? (<Date>year).getFullYear() : <number>year;
	//   https://en.wikipedia.org/wiki/ISO_week_date; western traditional/javascript  day numbering
	//	return (yr + Math.floor(yr / 4) - Math.floor(yr / 100) + Math.floor(yr / 400)) % 7;

	let date = new Date();
	date.setTime(0);
	date.setFullYear(yr);
	date.setMonth(11);
	date.setDate(31);
	return date.getDay();
}
/**
* Calculate on which day the year starts
* 0=sunday
 */
const firstDayOfTheYear = (year: number | Date): number => {
	let yr = (<Date>year).getFullYear ? (<Date>year).getFullYear() : <number>year;
	let date = new Date();
	date.setTime(0);
	date.setFullYear(yr);
	date.setMonth(0);
	date.setDate(1);
	return date.getDay();
}
export const getWeekCount = (year: number | Date): number => {
	let yr = (<Date>year).getFullYear ? (<Date>year).getFullYear() : <number>year;
	return lastDayOfTheYear(yr) == 4 || lastDayOfTheYear(yr - 1) == 3 ? 53 : 52;

}

export enum WeekNumberSystem {
	ISO8601 = "iso8601",
	WESTERN_TRADITIONAL = "western_traditional",
	MIDDLE_EASTERN = "middle_eastern",
	BROADCAST_CALENDAR = "broadcast_calendar"
}
export interface DataSystem {
	sunday: number
}
export interface WeekNumber {
	system:WeekNumberSystem,
	year: number,
	week:number
}
export const DATE_SYSTEM = {
	iso8601: {
		sunday: 6 //monday=0
	},
	western_traditional: {
		sunday: 0 //sunady=0
	},
	middle_eastern: {
		sunday: 1 //saturday=0
	},
	broadcast_calendar: {
		sunday: 6 //monday=0
	},
}
export const getDay = (date: Date, system?: WeekNumberSystem): number => {
	const day = date.getDay();
	//default to Javascript , i.e. WESTERN_TRADITIONAL
	const sys = system ? system : WeekNumberSystem.WESTERN_TRADITIONAL;
	const dayNumberForSunday = DATE_SYSTEM[sys].sunday;
	return (day + dayNumberForSunday) % 7;
}
/**
* Calculate the ISO8601 week number
* https://en.wikipedia.org/wiki/ISO_week_date
* 0=sunday
 */
export const getWeek = (date: Date): WeekNumber => {
	const year = date.getFullYear();
	const doy = getDayOfTheYear(date);
	const dow = getDay(date, WeekNumberSystem.ISO8601) + 1;   // (1=monday, 7=sunday)
	const week = Math.floor((10 + doy - dow) / 7);
	const system =  WeekNumberSystem.ISO8601;
	return Object.assign( { system: system }, week < 1 ? {year: year - 1, week: getWeekCount(year - 1) } : week > getWeekCount(year) ? { year: year + 1, week: 1 } : { year: year, week: week });
}

/**
* calculates the start date of given ISO8601 week number
 */
export const getWeekStart = (year: number | WeekNumber, week?: number): Date => {
	const yr = (<WeekNumber>year).week != undefined ? (<WeekNumber>year).year : <number>year;
	const wk = (<WeekNumber>year).week != undefined ? (<WeekNumber>year).week : week;

	//get january 1 for given year (local time)
	let date = new Date();
	date.setTime(0);//reset first to EPOCH
	date.setFullYear(yr);
	date.setMonth(0);
	date.setDate(1);
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setMilliseconds(0);
	//calculate the offset (in days) of the start of the  first week of the given year relative to the start of the year 
	const dayStartWeekYearOffset = (3 - ((date.getDay() + 2) % 7)) 
	//calculate the offset of the given week relative to the first week of the year
	const weekOffset = (wk - 1) * 7 
	//calculate the start of the given week
	date.setDate(date.getDate() + dayStartWeekYearOffset + weekOffset);

	return date;
}


//taken from https://www.typescriptlang.org/play
type Values<T extends {}> = T[keyof T];

type Tuplize<T extends {}[]> = Pick<T, Exclude<keyof T, Extract<keyof {}[], string> | number>>;

type _OneOf<T extends {}> = Values<{
	[K in keyof T]: T[K] & {
		[M in Values<{ [L in keyof Omit<T, K>]: keyof T[L] }>]?: undefined
	}
}>;

export type OneOf<T extends {}[]> = _OneOf<Tuplize<T>>;

//const _hue = 60;
//const _saturation = 80;
//const _lightness = 50;
//const _alpha = 0.8;
//const _hueRange = { from: 240, to:0 }; 
//const _saturationRange = { from: _saturation, to:_saturation }; 
//const _lightnessRange = { from: _lightness, to:_lightness };
//const _alphaRange = { from: _alpha, to:_alpha };
//
//export interface ColorGradientOptions{
//    valueRange: {min:number, max:number} , 
//    hueRange:{ from: number, to: number}, 
//    saturationRange:{ from: number, to: number},
//    lightnessRange:{ from: number, to: number},
//    alphaRange:{ from: number, to: number}    
//}
//export interface ColorMapperEntry {
//    value: number, 
//    color: Color     
//}
//
//
//export const ColorMap = ( map: ColorMapperEntry[], hideUnderflow = true, hideOverflow = false): ( (v:number) => string ) => {
//    //check for freak cases
//    if( !map || map.length===0 || (map.length===1 && hideUnderflow && hideOverflow)){
//        return (v:number) => 'hsla(0,0%,0%,0))';
//    } else {
//        if (map.length===1) {
//            //otherwise we will see one big colored plane
//            hideUnderflow = !hideOverflow;
//        }
//        //sort entries by value
//        map.sort( (entry0, entry1) => entry0.value - entry1.value );
//        const iMax = map.length-1;
//        //determine under- and overflow colors
//        const underflowColor = hideUnderflow ? 'hsla(0,0%,0%,0))' : `hsla(${ map[0].color.hue }, ${ map[0].color.saturation }%, ${ map[0].color.lightness  }%, ${ map[0].color.alpha } )`;
//        const overflowColor = hideOverflow ? 'hsla(0,0%,0%,0))' : `hsla(${ map[iMax].color.hue }, ${ map[iMax].color.saturation }%, ${ map[iMax].color.lightness  }%, ${ map[iMax].color.alpha } )`;
//        
//        //maps a value to an index
//        const mapperIndex = ( value: number ): number  => {
//            let mi = -1;
//            while( mi<iMax && value >= map[mi+1].value ) mi++;
//            return mi;
//        };
//        
//        //create the color mappers
//        let cm:((v:number)=>string)[]  = [];
//        for ( let i=1; i< map.length; i++) {
//            cm.push( ColorMapper(
//                    { min: map[i-1].value, max: map[i].value },
//                    { from: map[i-1].color.hue, to: map[i].color.hue },
//                    { from: map[i-1].color.saturation, to: map[i].color.saturation },
//                    { from: map[i-1].color.lightness, to: map[i].color.lightness },
//                    { from: map[i-1].color.alpha, to: map[i].color.alpha }
//                    ));
//        }
//        
//        return (v:number) => {
//            let cmi = mapperIndex(v);
//            return cmi<0 ? underflowColor : cmi >= cm.length ? overflowColor : cm[cmi](v);
//        }
//    }
//}
//
//export const ColorMapper = (
//        valueRange: {min:number, max:number} , 
//        hueRange:{ from: number, to: number}, 
//        saturationRange:{ from: number, to: number},
//        lightnessRange:{ from: number, to: number},
//        alphaRange:{ from: number, to: number}) => {
//    let hRange = hueRange ? hueRange : _hueRange;
//    let sRange = saturationRange ? saturationRange : _saturationRange;
//    let lRange = lightnessRange ? lightnessRange : _lightnessRange;
//    let aRange = alphaRange ? alphaRange : _alphaRange;
//    const inputRange = { from: valueRange.min, to: valueRange.max }; 
//    const hue = Scaler( inputRange, hRange );
//    const saturation = Scaler( inputRange, sRange );
//    const lightness = Scaler( inputRange, lRange );
//    const alpha = Scaler( inputRange, aRange, false );
//    
//    return (v: number) =>  v < valueRange.min ? 'hsla(300,80%,50%,0)':v > valueRange.max ? `hsla(${ hRange.to }, ${ sRange.to }%, ${  lRange.to  }%, ${ aRange.to } )`: `hsla(${ hue(v) }, ${ saturation(v) }%, ${  lightness(v)  }%, ${ alpha(v) } )`;
//}

export const Scaler = (inputRange: { from: number, to: number }, outputRange: { from: number, to: number }, round: boolean = true) => {
	const inputWidth = inputRange.to - inputRange.from;
	const outputWidth = outputRange.to - outputRange.from;
	const in2out = outputWidth / inputWidth;

	return round ? (input: number) => Math.round(outputRange.from + in2out * (input - inputRange.from)) : (input: number) => outputRange.from + in2out * (input - inputRange.from);
}

export const NearestNeighbourInterpolator = {
	value: (p: number[], t: number) => t < 0.5 ? p[0] : p[1],
	biValue: (p: number[][], tx: number, ty: number) => NearestNeighbourInterpolator.value([NearestNeighbourInterpolator.value(p[0], ty), NearestNeighbourInterpolator.value(p[1], ty)], tx),
	triValue: (p: number[][][], tx: number, ty: number, tz: number) => NearestNeighbourInterpolator.value([NearestNeighbourInterpolator.biValue(p[0], ty, tz), NearestNeighbourInterpolator.biValue(p[2], ty, tz)], tx)
}
export const LinearInterpolator = {
	value: (p: number[], t: number) => p[0] * (1 - t) + p[1] * t,
	biValue: (p: number[][], tx: number, ty: number) => LinearInterpolator.value([LinearInterpolator.value(p[0], ty), LinearInterpolator.value(p[1], ty)], tx),
	triValue: (p: number[][][], tx: number, ty: number, tz: number) => LinearInterpolator.value([LinearInterpolator.biValue(p[0], ty, tz), LinearInterpolator.biValue(p[2], ty, tz)], tx)
}
export const CubicInterpolator = {
	//https://www.paulinternet.nl/?page=bicubic
	value: (p: number[], t: number) => p[1] + 0.5 * t * (p[2] - p[0] + t * (2.0 * p[0] - 5.0 * p[1] + 4.0 * p[2] - p[3] + t * (3.0 * (p[1] - p[2]) + p[3] - p[0]))),
	biValue: (p: number[][], tx: number, ty: number) => CubicInterpolator.value([CubicInterpolator.value(p[0], ty), CubicInterpolator.value(p[1], ty), CubicInterpolator.value(p[2], ty), CubicInterpolator.value(p[3], ty)], tx),
	triValue: (p: number[][][], tx: number, ty: number, tz: number) => CubicInterpolator.value([CubicInterpolator.biValue(p[0], ty, tz), CubicInterpolator.biValue(p[1], ty, tz), CubicInterpolator.biValue(p[2], ty, tz), CubicInterpolator.biValue(p[3], ty, tz)], tx)
}
/**
  * Checks whether the given number sequence is monotoneous and returns it's range. The range
  * is the last value in the sequence minus the first value in the sequence. When the range is positive
  * the sequence is in increasing order (low values to high values). When the range is negative the
  * sequence is in decreasing order (high values to low values). When the range equals 0 then the 
  * sequence is not monotoneous
   * @return 0 when the sequence is not monotoneous, other wise the range from first till last element in the sequence. 
  */
export const getMonotoneousRange = (sequence: number[]): number => {
	if (sequence == undefined || sequence.length <= 1) return 0;
	const lastIndex = sequence.length - 1;
	const sequenceStart = sequence[0];
	const sequenceEnd = sequence[lastIndex];
	const sequenceMin = Math.min(sequenceStart, sequenceEnd);
	const directionIsUp = sequenceStart === sequenceMin;

	const sequenceIsMonotone = sequence.reduce((isMonotone: boolean, sequenceValue: number, sequenceIndex: number, sequence: number[]) => {
		if (sequenceIndex == 0) {
			return true;
		} else {
			return isMonotone && directionIsUp ? sequence[sequenceIndex - 1] < sequenceValue : sequence[sequenceIndex - 1] > sequenceValue;
		}
	}, true);

	return sequenceIsMonotone ? sequenceEnd - sequenceStart : 0;

}
export const looper = (length: number) => new Enumerable(indexGenerator(length));

class Enumerable {
	constructor(private iterator: Iterable<any>) {
	}

	*[Symbol.iterator]() {
		yield* this.iterator;
	}

	static *_map(iterator: Iterable<any>, mapperFunc: (value: any) => any) {
		for (let value of iterator) {
			yield mapperFunc(value);
		}
	}

	map(mapper: (value: any) => any) {
		this.iterator = Enumerable._map(this.iterator, mapper);
		return this;
	}

	reduce(reducer: (accu: any, value: any) => any, startState: any) {
		let state = startState;
		for (let value of this.iterator) {
			state = reducer(state, value);
		}
		return state;
	}
	array() {
		return this.reduce((list, value) => { list.push(value); return list; }, []);
	}
}

const indexGenerator = (length: number) => {
	return createLoopGenerator(0, index => index < length, index => index + 1)();
}
const createLoopGenerator = (start: any, test: (i: any) => boolean, step: (i: any) => any) => {
	return function*() {
		let i;
		for (i = start; test(i); i = step(i)) {
			yield i;
		}
	}
}


/*
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
const defaultDiacriticsRemovalMap = [
	{ 'base': 'A', 'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' },
	{ 'base': 'AA', 'letters': '\uA732' },
	{ 'base': 'AE', 'letters': '\u00C6\u01FC\u01E2' },
	{ 'base': 'AO', 'letters': '\uA734' },
	{ 'base': 'AU', 'letters': '\uA736' },
	{ 'base': 'AV', 'letters': '\uA738\uA73A' },
	{ 'base': 'AY', 'letters': '\uA73C' },
	{ 'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
	{ 'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
	{ 'base': 'D', 'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0' },
	{ 'base': 'DZ', 'letters': '\u01F1\u01C4' },
	{ 'base': 'Dz', 'letters': '\u01F2\u01C5' },
	{ 'base': 'E', 'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' },
	{ 'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
	{ 'base': 'G', 'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' },
	{ 'base': 'H', 'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' },
	{ 'base': 'I', 'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' },
	{ 'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248' },
	{ 'base': 'K', 'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' },
	{ 'base': 'L', 'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' },
	{ 'base': 'LJ', 'letters': '\u01C7' },
	{ 'base': 'Lj', 'letters': '\u01C8' },
	{ 'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
	{ 'base': 'N', 'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' },
	{ 'base': 'NJ', 'letters': '\u01CA' },
	{ 'base': 'Nj', 'letters': '\u01CB' },
	{ 'base': 'O', 'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C' },
	{ 'base': 'OI', 'letters': '\u01A2' },
	{ 'base': 'OO', 'letters': '\uA74E' },
	{ 'base': 'OU', 'letters': '\u0222' },
	{ 'base': 'OE', 'letters': '\u008C\u0152' },
	{ 'base': 'oe', 'letters': '\u009C\u0153' },
	{ 'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
	{ 'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
	{ 'base': 'R', 'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' },
	{ 'base': 'S', 'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' },
	{ 'base': 'T', 'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' },
	{ 'base': 'TZ', 'letters': '\uA728' },
	{ 'base': 'U', 'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' },
	{ 'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
	{ 'base': 'VY', 'letters': '\uA760' },
	{ 'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
	{ 'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
	{ 'base': 'Y', 'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' },
	{ 'base': 'Z', 'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' },
	{ 'base': 'a', 'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' },
	{ 'base': 'aa', 'letters': '\uA733' },
	{ 'base': 'ae', 'letters': '\u00E6\u01FD\u01E3' },
	{ 'base': 'ao', 'letters': '\uA735' },
	{ 'base': 'au', 'letters': '\uA737' },
	{ 'base': 'av', 'letters': '\uA739\uA73B' },
	{ 'base': 'ay', 'letters': '\uA73D' },
	{ 'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
	{ 'base': 'c', 'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184' },
	{ 'base': 'd', 'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' },
	{ 'base': 'dz', 'letters': '\u01F3\u01C6' },
	{ 'base': 'e', 'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' },
	{ 'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
	{ 'base': 'g', 'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' },
	{ 'base': 'h', 'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' },
	{ 'base': 'hv', 'letters': '\u0195' },
	{ 'base': 'i', 'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' },
	{ 'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
	{ 'base': 'k', 'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' },
	{ 'base': 'l', 'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' },
	{ 'base': 'lj', 'letters': '\u01C9' },
	{ 'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
	{ 'base': 'n', 'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' },
	{ 'base': 'nj', 'letters': '\u01CC' },
	{ 'base': 'o', 'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275' },
	{ 'base': 'oi', 'letters': '\u01A3' },
	{ 'base': 'ou', 'letters': '\u0223' },
	{ 'base': 'oo', 'letters': '\uA74F' },
	{ 'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
	{ 'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
	{ 'base': 'r', 'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' },
	{ 'base': 's', 'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' },
	{ 'base': 't', 'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' },
	{ 'base': 'tz', 'letters': '\uA729' },
	{ 'base': 'u', 'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' },
	{ 'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
	{ 'base': 'vy', 'letters': '\uA761' },
	{ 'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
	{ 'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
	{ 'base': 'y', 'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' },
	{ 'base': 'z', 'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }
];

let diacriticsMap: { [key: string]: string } = {};
for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
	let letters = defaultDiacriticsRemovalMap[i].letters;
	for (let j = 0; j < letters.length; j++) {
		diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
	}
}

export const removeDiacritics = (str: string): string => {
	return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\u0000-\u007E]/g, function(a) {
		return diacriticsMap[a] || a;
	});
}
export const jsonCopy = (datum: any): any => {
	return JSON.parse(JSON.stringify(datum));
}
export const lookupProperty = (datum: any, property: string): any => {
	if (datum && property && property.length > 0) {
		let fields = property.split('.');
		return fields.reduce((value: any, field: string) => {
			if (value !== undefined && field !== undefined && field.length > 0) {
				return value[field];
			}
			return undefined;
		}, datum);
	} else {
		return undefined;
	}
}
export const hasProperty = (datum: any, property: string): boolean => {
	if (datum && property && property.length > 0) {
		let fields = property.split('.');
		return _hasProperty(datum, fields, 0);
	}
}
const _hasProperty = (datum: any, fields: string[], index: number): boolean => {
	if (datum === undefined || index >= fields.length) return false;
	if (index === (fields.length - 1) && datum.hasOwnProperty(fields[index])) return true;
	return _hasProperty(datum[fields[index]], fields, index + 1);
}
export const defaultTo = (property: any, defaultValue: any): any => {
	return property != null ? property : defaultValue;
}

type objectType = Record<string, any>
// notice the return spec "obj is objectType" - it is saying believe me this an objectType, 
// Inside the guard you check it at run time, so it's not an empty promise.
const isObject = (obj: unknown): obj is objectType => {
	return <boolean>obj && typeof obj === 'object'
}

const deepMergeInnerDedupeArrays = (target: objectType, source: objectType): objectType => {
	function uniquify(a: any[]): any[] {
		return a.filter((v, i) => a.indexOf(v) === i);
	}
	Object.keys(source).forEach((key: string) => {
		const targetValue = target[key];
		const sourceValue = source[key];
		if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
			target[key] = uniquify(targetValue.concat(sourceValue));
		} else if (isObject(targetValue) && Array.isArray(sourceValue)) {
			target[key] = sourceValue;
		} else if (Array.isArray(targetValue) && isObject(sourceValue)) {
			target[key] = sourceValue;
		} else if (isObject(targetValue) && isObject(sourceValue)) {
			target[key] = deepMergeInnerDedupeArrays(Object.assign({}, targetValue), sourceValue);
		} else {
			target[key] = sourceValue;
		}
	});
	return target;
}

export const merge = (...objects: objectType[]): objectType => {
	if (objects.length === 0)
		return {};
	if (objects.length === 1)
		return objects[0];
	if (objects.some(object => !isObject(object))) {
		throw new Error('deepMerge: all values should be of type "object"');
	}
	const target = objects.shift() as objectType;
	let source: objectType;
	while (source = objects.shift() as objectType) {
		deepMergeInnerDedupeArrays(target, source);
	}
	return target;
}
export const isEqualJSON = ( obj0: any, obj1: any): boolean =>{
	    // If both x and y are null or undefined and exactly the same
    if ( obj0 === obj1 ) {
        return true;
    }

    // If they are not strictly equal, they both need to be Objects
    if ( ! ( obj0 instanceof Object ) || ! ( obj1 instanceof Object ) ) {
        return false;
    }

    // They must have the exact same prototype chain, the closest we can do is
    // test the constructor.
    if ( obj0.constructor !== obj1.constructor ) {
        return false;
    }

    for ( var p in obj0 ) {
        // Inherited properties were tested using x.constructor === y.constructor
        if ( obj0.hasOwnProperty( p ) ) {
            // Allows comparing x[ p ] and y[ p ] when set to undefined
            if ( ! obj1.hasOwnProperty( p ) ) {
                return false;
            }

            // If they have the same strict value or identity then they are equal
            if ( obj0[ p ] === obj1[ p ] ) {
                continue;
            }

            // Numbers, Strings, Functions, Booleans must be strictly equal
            if ( typeof( obj0[ p ] ) !== "object" ) {
                return false;
            }

            // Objects and Arrays must be tested recursively
            if ( !isEqualJSON( obj0[ p ],  obj1[ p ] ) ) {
                return false;
            }
        }
    }

    for ( p in obj1 ) {
        // allows x[ p ] to be set to undefined
        if ( obj1.hasOwnProperty( p ) && ! obj0.hasOwnProperty( p ) ) {
            return false;
        }
    }
    return true;
} 
